import { useTitleChange } from '@msaf/core-react'
import ExternalDocumentReferencesWrapper from '../../../../components/well-forms/external-document-references/wrapper'

export default function ListExternalDocumentReferences() {
  useTitleChange('View Well | External Document Reference')

  return <ExternalDocumentReferencesWrapper />
}
